
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    data: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      currentPageNumber: this.currentPage,
    };
  },
  computed: {
    totalPages(): number {
      return Math.ceil(this.data / this.pageSize);
    },
  },
  methods: {
    pageChanged() {
      this.$emit('page-changed', this.currentPageNumber);
    },
  },
});
